'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'badge-check';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f336';
var svgPathData = 'M256 0c36.1 0 68 18.1 87.1 45.6 33-6 68.4 3.8 93.9 29.3s35.3 60.9 29.3 93.9C493.9 188 512 219.9 512 256s-18.1 68-45.6 87.1c6 33-3.8 68.4-29.3 93.9s-60.9 35.3-93.9 29.3C324 493.9 292.1 512 256 512s-68-18.1-87.1-45.6c-33 6-68.4-3.8-93.9-29.3s-35.3-60.9-29.3-93.9C18.1 324 0 292.1 0 256s18.1-68 45.6-87.1c-6-33 3.8-68.4 29.3-93.9s60.9-35.3 93.9-29.3C188 18.1 219.9 0 256 0zm0 32c-28.3 0-53 15.9-65.4 39.4l-6.2 11.7-12.6-3.9c-25.4-7.8-54.1-1.6-74.2 18.4s-26.2 48.8-18.4 74.2l3.9 12.6-11.7 6.2C47.9 203 32 227.7 32 256s15.9 53 39.4 65.4l11.7 6.2-3.9 12.6c-7.8 25.4-1.6 54.1 18.4 74.2s48.8 26.2 74.2 18.4l12.6-3.9 6.2 11.7C203 464.1 227.7 480 256 480s53-15.9 65.4-39.4l6.2-11.7 12.6 3.9c25.4 7.8 54.1 1.6 74.2-18.4s26.2-48.7 18.4-74.1l-3.9-12.7 11.7-6.2C464.1 309 480 284.3 480 256s-15.9-53-39.4-65.4l-11.7-6.2 3.9-12.7c7.8-25.4 1.6-54.1-18.4-74.1s-48.8-26.2-74.2-18.4l-12.6 3.9-6.2-11.7C309 47.9 284.3 32 256 32zM358.3 176.1l-9.4 12.9-105.6 145.2-11.2 15.4-13.2-13.7-54.4-56.3-11.1-11.5 23-22.2c2.4 2.5 19.8 20.5 52.3 54.1l94.4-129.8 9.4-12.9 25.9 18.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBadgeCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;